import { render, staticRenderFns } from "./MainLedgerDetailCreate.vue?vue&type=template&id=b7d118d6"
import script from "./MainLedgerDetailCreate.vue?vue&type=script&lang=js"
export * from "./MainLedgerDetailCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports